var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-choice-item"},[_c('div',{staticClass:"mb-2 image-wrap"},_vm._l((_vm.item.content.image),function(img){return _c('el-image',{key:img.url,attrs:{"src":img.url,"preview-src-list":[img.url]}})}),1),_c('div',{staticClass:"px-3 py-2.5"},[_vm._t("default")],2),_vm._t("vote")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }